import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const usePageView = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/admin")) return;

    supabase.functions
      .invoke("track-pageview", {
        body: { page_path: path, user_agent: navigator.userAgent },
      })
      .catch(() => {});
  }, [location.pathname]);
};

export default usePageView;
